import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenLayout from './HiddenLayout';
import Blocked from './Icons/Blocked';
import Button from '../../Button';
var ArtistBlockedOverlay = function (_a) {
    var _b = _a.deviation, deviationId = _b.deviationId, author = _b.author, deviation = _a.deviation, unblockDeviant = _a.unblockDeviant, props = __rest(_a, ["deviation", "deviation", "unblockDeviant"]);
    var t = useTranslation().t;
    return (React.createElement(HiddenLayout, __assign({ deviation: deviation, icon: React.createElement(Blocked, null), title: t('deviationview.blocked.artist'), text: t('deviationview.blocked.artist.text'), button: author && (React.createElement(Button, { view: "b14", height: "medium", onClick: function () { return author && unblockDeviant(author.userId, deviationId); } }, t('deviationview.blocked.unblockDeviant'))) }, props)));
};
ArtistBlockedOverlay.displayName = 'ArtistBlockedOverlay';
export default ArtistBlockedOverlay;
//# sourceMappingURL=ArtistBlocked.js.map